import { create } from "zustand"

type GlobalParamsStore = {
  jwt: string
  ipAddress: string
  queryString: string
  hasInformationDisplayBeenVisited: boolean
  outGoingUrl: string | URL
  setJwt: (token: string) => void
  setIpAddress: (ipAddress: string) => void
  setQueryString: (queryString: string) => void
  setInformationDisplayVisit: (visited: boolean) => void
  setOutgoingUrl: (url: string | URL) => void
}

const useGlobalParamsStore = create<GlobalParamsStore>((set) => ({
  jwt: "",
  ipAddress: "",
  queryString: "",
  hasInformationDisplayBeenVisited: false,
  outGoingUrl: "",
  setJwt: (jwt) => set({ jwt }),
  setIpAddress: (ipAddress) => set({ ipAddress }),
  setQueryString: (queryString) => set({ queryString }),
  setInformationDisplayVisit: (visited) =>
    set({ hasInformationDisplayBeenVisited: visited }),
  setOutgoingUrl: (url) => set({ outGoingUrl: url }),
}))

export default useGlobalParamsStore
